import { render, staticRenderFns } from "./EsteroList.vue?vue&type=template&id=71bd19f6&scoped=true&"
import script from "./EsteroList.vue?vue&type=script&lang=js&"
export * from "./EsteroList.vue?vue&type=script&lang=js&"
import style0 from "./EsteroList.vue?vue&type=style&index=0&id=71bd19f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bd19f6",
  null
  
)

export default component.exports